import { render } from "./course_content.vue?vue&type=template&id=f151826a&scoped=true"
import script from "./course_content.vue?vue&type=script&lang=js"
export * from "./course_content.vue?vue&type=script&lang=js"

import "./course_content.vue?vue&type=style&index=0&id=f151826a&lang=css"
import "./course_content.vue?vue&type=style&index=1&id=f151826a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f151826a"]])

export default __exports__